import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminGuard } from '../core/guards/admin.guard';
import { HubComponent } from './components/hub/hub.component';
import { ImportExportComponent } from './components/import-export/import-export.component';
import { ShowGLNComponent } from './components/show-gln/show-gln.component';

const routes: Routes = [
  { path:'', component: HubComponent},
  { path: 'creer', canActivate: [AdminGuard], component: ShowGLNComponent},
  { path: 'details', children: [
    {path: ':id', component: ShowGLNComponent},
    {path: 'modifier/:id', component: ShowGLNComponent}
  ]},
  { path: 'importer', canActivate: [AdminGuard], component: ImportExportComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HubRoutingModule { }
